<template>

    <div class="relative overflow-hidden bg-white border-t-4 border-accent">
        <div class="py-6 tablet-sm:py-12
                    bg-secondary-bg">
            <div
                class="max-w-72 mobile-lg:max-w-full mobile-lg:px-4 tablet-sm:max-w-2xl tablet-lg:max-w-4xl laptop-lg:max-w-6xl desktop:max-w-7xl mx-auto flex items-center justify-between"
            >
                <div
                    class="flex py-2 tablet-sm:py-4 laptop-sm:py-8 flex-nowrap tablet-sm:flex-wrap justify-center
                           items-center items-stretch w-full gap-x-2 bg-white
                           border-double border-secondary-accent border-4"
                >
                    <div
                        class="px-2 tablet-sm:px-0 laptop-sm:px-8
                        max-w-68 tablet-sm:max-w-xl tablet-lg:max-w-3xl
                        laptop-lg:max-w-5xl desktop:max-w-6xl
                        pt-2 tablet-sm:pt-3 laptop-sm:pt-4
                        pb-2 tablet-sm:pb-0 laptop-lg:pb-4
                        laptop-sm:border-accent laptop-sm:border-x-2 w-full
                        flex flex-wrap"
                    >
                        <div class="w-full">
                            <div class="w-full">
                                <div v-if="breadcrumbs.length" class="flex items-center">
                                    <Breadcrumbs v-for="(crumb, index) in breadcrumbs" :key="index" :showChevron="index !== 0">
                                        <template v-if="index === 0">
                                            <Link class="text-black" :href="'/'">{{ crumb }}</Link>
                                        </template>
                                        <template v-else>
                                            {{ crumb }}
                                        </template>
                                    </Breadcrumbs>
                                </div>
                                <MainHead v-if="header">{{ header }}</MainHead>
                            </div>
                            <slot></slot>
                        </div>
                    </div>
                </div>
                <div class="flex"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import MainHead from "@/Components/PageContent/MainHead.vue";
import Breadcrumbs from "../../Components/PageContent/Breadcrumbs.vue";
import { Link } from "@inertiajs/vue3";


defineProps({
    id: { type: String, default: null },
    breadcrumbs: { type: Array, default: () => [] },
    header: { type: String, default: '' },
});
</script>
